import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';

// Routes 

import { getDoctors, getGroups } from '../../../routes/hacker/users';
import { setDashboardSection } from '../../../redux/features/general/navigation';
import { setInitialRendering, setIsGroupInfoPopupOpened } from '../../../redux/features/hacker/users/groupsAccess';
// Components 

import ListHeader from '../../hacker/doctors/ListHeader';
import GroupRow from './GroupRow';
import LinearProgress from '@mui/material/LinearProgress';

// Icons 

import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

// import Dropdown from './Dropdown';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { setGroups, setIsRefreshGroups, setSelectedGroup } from '../../../redux/features/hacker/users/groupsAccess';
import Legend from './Legend';
import Section from '../../general/containers/Section';

const GroupsList: React.FC = () => {

    const { t } = useTranslation();
    
    const dispatch = useAppDispatch();

    const colors = useAppSelector(state => state.theme.colors);  

    const isRefreshGroups = useAppSelector(state => state.groupsAccess.isRefreshGroups);  
    const selectedGroup = useAppSelector(state => state.groupsAccess.selectedGroup);  
    const groups = useAppSelector(state => state.groupsAccess.groups);  
    const initialRendering = useAppSelector(state => state.groupsAccess.initialRendering);  
    const isGroupInfoPopupOpened = useAppSelector((state) => state.groupsAccess.isGroupInfoPopupOpened); 

    const [postionX, setPositionX] = useState(0); 
    const [positionY, setPositionY] = useState(0); 

    // -- 

    const getGroupsList = async () => { 

      const res = await getGroups() as any; 

      if (res.data.status === 200) { 

        dispatch(setGroups(res.data.groups)); 

      };

    }; 

    // -- 

    const handleSelection = (e: any, group: any) => { 

      if (selectedGroup) { 

        if (selectedGroup?._id == group?._id) { 

          dispatch(setSelectedGroup(null)); 

          return; 
  
        }; 

      }; 

      setPositionX(e.pageX);
      setPositionY(e.pageY); 

      dispatch(setSelectedGroup(group)); 
      dispatch(setIsGroupInfoPopupOpened(true)); 

    }; 

    // -- 

    const changeSection = () => { 

      dispatch(setDashboardSection('createDoctor')); 

    }; 

    // -- 

    useEffect(() => { 

      if (initialRendering) { 

          getGroupsList(); 

          dispatch(setInitialRendering(false)); 

      }; 

    },[initialRendering]); 

    // -- 

    useEffect(() => { 

      if (isRefreshGroups) { 

        getGroupsList(); 

        dispatch(setIsRefreshGroups(false)); 

      }; 

    },[isRefreshGroups]); 

    // -- 
    
    return (

        <Section
          extraStyle={{ 
            backgroundColor: colors?.container,
            paddingLeft: '3vw', 
          }}
        >      
            
            <Legend />

            { groups?.length >= 1 && 
            <Box sx={{ 
                overflow: 'auto',
                width: '100%',
                marginTop: '2vh' }}>
        
                <List dense>
        
                {groups?.map((group, index) => (
        
                    <ListItem sx={{ color: colors?.text }} onClick={(e) => handleSelection(e, group)} button key={index}>

                        <GroupRow 
                            item={group}
                        /> 
       
                    </ListItem>
                ))}
        
                </List>
        
            </Box>}

            {groups?.length === 0 &&         
          
            <Box sx={{ 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'space-evenly', 
              height: '100%',
              width: '80%', 
          }}>

              <Box
                  sx={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
              }}>

                  <LinearProgress sx={{ width: 500, marginBottom: 10 }} /> 

                  <Box>Retrieving Groups...</Box>

              </Box>

          </Box>}

          {/* { selectedGroup && <Dropdown positionX={postionX} positionY={positionY - 30} />} */}

          <AddCircleIcon 
            onClick={changeSection}
            sx={{ 
              width: 70,
              height: 70, 
              color: 'rgb(45, 207, 196)', 
              position: 'absolute', 
              bottom: 30, 
              right: 30, 
              cursor: 'pointer',
              '&:hover' : { color: 'rgb(65, 227, 216)'}
            }}
          />

        </Section>
    
      );

};

export default GroupsList;